import React, {useCallback, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import EshopSysadminList from '../components/EshopSysadminList.js';

// Hledaný výraz z cesty /eshopsysadmin/:directSearch. window.location tady nestačí –
// po pushState níže ukazuje na /eshopsysadmin, zatímco router location drží
// skutečnou cestu.
const getPathSearch = (pathname) => (typeof pathname.split('/')[2] != 'undefined' ? decodeURI(pathname.split('/')[2]) : '');

export default function EshopSysadmin({usrInfo, timerCnt}) {
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [searchValue, setSearchValue] = useState(() => getPathSearch(location.pathname));
	const [locationKey, setLocationKey] = useState(location.key);

	// Změna location: když se klikne na uživatele (např. v /member) a už jsme na /eshopsysadmin,
	// komponenta se nepřemountuje – hledání se ale přepne a seznam se znovu načte (jako v /user).
	// Srovnáme to hned při renderu, ať se seznam nenačítá dvakrát (nejdřív se starou hodnotou).
	if (location.key !== locationKey) {
		setLocationKey(location.key);
		setSearchValue(getPathSearch(location.pathname));
	}

	useEffect(() => {
		if (getPathSearch(location.pathname) !== '') {
			window.history.pushState({}, document.title, '/eshopsysadmin');
		}
	}, [location]);

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => setSearchValue(e)} />

				<div className={`page eshop-page eshop-page--sysadmin${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<EshopSysadminList usrInfo={usrInfo} searchValue={searchValue} reloadKey={locationKey} onLoadingChange={handleLoadingChange} />
				</div>
			</div>
		</>
	);
}
